import { store$ } from '@redux/store';
import fastdom from 'fastdom';
import { selectPage } from 'features/articleSearchResultsFacets';
import { distinctUntilChanged, filter, map, partition } from 'rxjs';

/**
 * Hides the featured article by setting the "hidden" attribute on the element.
 */
const hideFeaturedArticle = function() {
  fastdom.mutate(() => {
    const featuredArticleElement = document.querySelector('[data-component="featured-article"]');
    if (featuredArticleElement) {
      featuredArticleElement.setAttribute('hidden', '');
    }
  });
};

/**
 * Shows the featured article by removing the "hidden" attribute from the element.
 */
const showFeaturedArticle = function() {
  fastdom.mutate(() => {
    const featuredArticleElement = document.querySelector('[data-component="featured-article"]');
    if (featuredArticleElement) {
      featuredArticleElement.removeAttribute('hidden');
    }
  });
};

/**
 * Observable that listens for page changes in the Redux store.
 * Emits the current page number when it changes.
 * @type {Observable<number>}
 */
const onPageChange$ = store$.pipe(
  map(selectPage),
  filter(Boolean),
  distinctUntilChanged(),
);

const [hideFeaturedArticle$, showFeaturedArticle$] = partition(
  onPageChange$, (page) => page > 1
);

// Subscribes to show or hide the featured article based on the current page.
showFeaturedArticle$.subscribe(showFeaturedArticle);
hideFeaturedArticle$.subscribe(hideFeaturedArticle);